import { useEffect, useState } from 'react';
import { BarChart, BarChartProps } from '@mui/x-charts/BarChart';
import { formatMoney } from '@dill/dill-shared';
import { useAppSelector } from '../../../../../../redux/store';
import { COLORS } from '../../../../../../utils/colors';

const getResponsiveConfig = (): Partial<BarChartProps> => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

  return {
    height: isMobile ? 350 : 400,
    margin: {
      left: isMobile ? 60 : 80,
      right: isMobile ? 15 : 20,
      top: 20,
      bottom: isMobile ? 80 : 60,
    },
    hideLegend: false,
  };
};

function SupplierTotalPaymentsChart() {
  const { supplierAnnualReport } = useAppSelector((state) => state.reports);
  const [dataSet, setSataSet] = useState<
    {
      totalCardPayments: number;
      totalBankPayments: number;
      month: string;
    }[]
  >();
  useEffect(() => {
    if (supplierAnnualReport) {
      const dd = supplierAnnualReport.yearMonthlySummary.map((data) => {
        return {
          totalCardPayments: data.paymentTypes.CARD?.totalAmount || 0,
          totalBankPayments: data.paymentTypes.BANK?.totalAmount || 0,
          month: data.month,
        };
      });
      setSataSet(dd);
    }
    return () => {};
  }, [supplierAnnualReport]);

  return (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4 mb-6">
        <div>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1">
            Total payments initiated on Dill
          </h3>
          <p className="text-sm text-gray-500">Monthly breakdown by payment method</p>
        </div>
      </div>
      {dataSet && (
        <BarChart
          borderRadius={8}
          dataset={dataSet}
          xAxis={[
            {
              dataKey: 'month',
              tickLabelStyle: {
                fontSize: 12,
                fill: COLORS.TEXT_SECONDARY,
                fontFamily: 'Inter',
                fontWeight: 'bold',
              },
            },
          ]}
          series={[
            {
              dataKey: 'totalCardPayments',
              label: 'Card Payments',
              color: COLORS.PRIMARY_500,
              valueFormatter: (value: number | null) => {
                return `${formatMoney(value || 0, 2)}`;
              },
              stack: 'total',
            },
            {
              dataKey: 'totalBankPayments',
              label: 'Bank Payments',
              color: COLORS.SUCCESS_500,
              valueFormatter: (value: number | null) => {
                return `${formatMoney(value || 0, 2)}`;
              },
              stack: 'total',
            },
          ]}
          yAxis={[
            {
              width: 80,
              tickLabelStyle: {
                fontSize: 11,
                fill: COLORS.TEXT_SECONDARY,
                fontFamily: 'Inter',
                fontWeight: 'bold',
              },
              domainLimit: (min, max) => {
                return { min, max: Math.floor(max + (max * 10) / 100) };
              },
              valueFormatter: (value: number) => {
                return formatMoney(value, 0);
              },
            },
          ]}
          grid={{ horizontal: true }}
          // Responsive configuration
          {...getResponsiveConfig()}
        />
      )}
    </div>
  );
}

export default SupplierTotalPaymentsChart;
